// extracted by mini-css-extract-plugin
module.exports = {"container":"payment-modal_container__2rRcy","modal":"payment-modal_modal__dhWi6","form-description":"payment-modal_form-description__5fAgp"};